module.exports = __webpack_public_path__ + "static/media/17.cc7a53a4.jpeg";